import styled from "styled-components";

export const StyledPackagingInspectionPage = styled.div``;

export const LabelText = styled.span`
//   position: absolute;
  float: left;
  padding: 5px;
`

export const SmallLabelText = styled.span`
  font-size: 12px;
  float: left;
  padding: 5px;
`

export const HeaderLabelText = styled.span`
  font-weight: bold;
  margin: auto;
`

export const TitleLabelText = styled.span`
  font-weight: bold;
  font-size: 16px;
  overflow: hidden;
  float: center;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin: auto;
`;